import React from 'react';
import PropTypes from 'prop-types';
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-react';
import { P } from '../../theme/typography';
import { Img } from '../ReactComponent/Image';
import {
  SectionTitle, Section, LeftColumn, RightColumn, ButtonGroup,
} from './css';
import { anchor } from '../../utils/func';

const MediaContent = ({ fields }) => {
  const { primaryLink } = fields;
  const hasPrimary = primaryLink && primaryLink.value && primaryLink.value.href;
  const { secondaryLink } = fields;
  const hasSecondary = secondaryLink && secondaryLink.value && secondaryLink.value.href;

  return (
    <>
      {fields.heading && fields.heading.value
      && (
      <SectionTitle>
        <Text field={fields.heading} />
      </SectionTitle>
      )}
      {fields.content && <P><RichText field={fields.content} /></P>}
      {(hasPrimary || hasSecondary)
      && (
      <ButtonGroup className="right">
        {hasSecondary
              && (
              <Link field={secondaryLink} className="secondaryButton">
                <span className="icon" />
                {secondaryLink.value.text}
              </Link>
              )}
        {hasPrimary
              && (
              <Link field={primaryLink} className="primaryButton submit">
                <span className="icon" />
                {primaryLink.value.text}
              </Link>
              )}
      </ButtonGroup>
      )}
    </>
  );
};

const SectionClass = (isLeft, imageOnRight, useEqualLayoutWidth) => {
  if (useEqualLayoutWidth) {
    return 'flex-50';
  }

  if (isLeft) {
    return imageOnRight ? 'flex-60' : 'flex-40';
  }

  return imageOnRight ? 'flex-40' : 'flex-60';
};

const ArticleSectionMedia = ({ fields }) => {
  const imageOnRight = fields.imageOnRight && fields.imageOnRight.value;
  const useEqualLayoutWidth = fields['use Equal Layout Width'] && fields['use Equal Layout Width'].value;
  const id = fields.anchor && fields.anchor.value ? anchor(fields.anchor.value) : '';

  return (
    <Section id={id} className="static-section">
      <LeftColumn className={SectionClass(true, imageOnRight, useEqualLayoutWidth)}>
        {imageOnRight
          ? <MediaContent fields={fields} />
          : (
            fields.image && <Img field={fields.image} />
          )}
      </LeftColumn>
      <RightColumn className={SectionClass(false, imageOnRight, useEqualLayoutWidth)}>
        {imageOnRight ? (
          fields.image && <Img field={fields.image} />
        )
          : <MediaContent fields={fields} />}
      </RightColumn>
    </Section>
  );
};

MediaContent.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.shape({
      value: PropTypes.string,
    }),
    content: PropTypes.shape({
      value: PropTypes.string,
    }),
    primaryLink: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    secondaryLink: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
  }),
};

ArticleSectionMedia.propTypes = {
  fields: PropTypes.shape({
    anchor: PropTypes.shape({
      value: PropTypes.string,
    }),
    imageOnRight: PropTypes.shape({
      value: PropTypes.bool,
    }),
    'use Equal Layout Width': PropTypes.shape({
      value: PropTypes.bool,
    }),
    heading: PropTypes.shape({
      value: PropTypes.string,
    }),
    content: PropTypes.shape({
      value: PropTypes.string,
    }),
    primaryLink: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    secondaryLink: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    image: PropTypes.object,
  }),
};

export default ArticleSectionMedia;
